import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NotificationDto, NotificationsService } from '@app/modules/notifications/notifications.service';

@Component({
  selector: 'app-notification-detail-modal',
  templateUrl: './notification-detail-modal.component.html',
  styleUrls: ['./notification-detail-modal.component.scss'],
  providers: [NotificationsService],
})
export class NotificationDetailModalComponent {
  @Input() visible = false;
  @Input() notification: NotificationDto | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();

  constructor(
    private notificationsService: NotificationsService,
    private message: NzMessageService,
  ) {}

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  downloadAttachment(): void {
    if (!this.notification) {
      return;
    }
    this.notificationsService.downloadAttachment(this.notification.notificationId, false).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.notification?.attachmentFileName || 'attachment';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: () => this.message.error('Không tải được file đính kèm.'),
    });
  }
}
